<form
	(submit)="$event.preventDefault()"
	[formGroup]="group"
	cdkTrapFocus
	class="flex flex-col"
>
	<mat-toolbar
		class="bg-transparent"
		id="record_toolbar_wrapper"
	>
		<div class="mr-2 flex w-full min-w-0">
			<mat-form-field
				#descWrapper="matAutocompleteOrigin"
				appearance="fill"
				class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain min-w-0 flex-auto items-stretch !text-base"
				matAutocompleteOrigin
				role="listbox"
			>
				<input
					(keydown.enter)="$event.preventDefault(); $event.stopPropagation()"
					(keyup.arrowdown)="focusAutocomplete()"
					[matAutocomplete]="descriptionList"
					[matAutocompleteConnectedTo]="descWrapper"
					[placeholder]="((SelectedRecordMode !== modes.Timer ? 'RECORD_TOOLBAR_DESCRIPTION_PAST' : 'RECORD_TOOLBAR_DESCRIPTION') | translate) + ((settings$ | async)?.requireName ? ' *' : '')"
					#nameFocus
					formControlName="name"
					id="record_toolbar_name"
					matInput
					type="text"
				>
				<div
					*ngIf="{
            task: value$task | async,
            project: selectedProject$ | async,
            settings: settings$ | async,
          } as projectDetails"
					class="flex h-full flex-row items-stretch justify-start gap-2"
					matSuffix
				>
					<mat-divider
						class="mat-divider-vertical ml-2 self-center"
						vertical
					></mat-divider>
					<button
						(click)="$event.preventDefault(); $event.stopPropagation(); this.openClientProjectPickerDialog($event)"
						(keyup.enter)="$event.preventDefault(); $event.stopPropagation(); this.openClientProjectPickerDialog($event)"
						[matTooltipOptions]="{ delay: [500, 0] }"
						[matTooltipTemplate]="projectPickerTooltip"
						[matTooltipTemplateContext]="projectTooltipData$ | async"
						class="flex cursor-pointer flex-row items-center justify-start gap-1.5 border-0 shadow-none"
						id="record_toolbar_project"
						matTooltip
						tabindex="0"
					>
						@if(getProjectColorNonDefault(projectDetails.project?.id); as color) {
						<div
							[matTooltip]="'project.color' | translate"
							[style.backgroundColor]="projectDetails.project?.color ?? color"
							class="project-color-dot flex-shrink-0 self-center"
						></div>
						}
						<span class="truncate">
							{{
								projectDetails.project | defaultEntityTranslate: 'project' : 'project.none' : null : true | translate | truncate: 20
							}}
						</span>
						<span>{{
							projectDetails.settings?.requireProject && (!projectDetails.project || projectDetails.project?.useAsDefault) ? ' *' : ''
						}}</span>
						<div class="mat-bg-30 h-1 w-1 rounded-full"></div>
						<span>{{
							(projectDetails.task?.name || ('task.none' | translate) | truncate: 20) + (projectDetails.settings?.requireTask && !projectDetails.task ? ' *' : '')
						}}</span>
					</button>
				</div>
			</mat-form-field>
			<mat-autocomplete
				[displayWith]="this.autoDisplayWith"
				#descriptionList="matAutocomplete"
				#searchACRef
				class="record-toolbar-autocomplete-panel !max-h-full overflow-hidden !rounded-lg"
				panelClass="record-toolbar-autocomplete-panel"
			>
				<div class="scroll-y my-2 max-h-128 min-h-0 flex-1">
					<ng-container
						*ngIf="{
              suggestions: (entries$suggestions | async),
              times: (entries$latestTimes | async),
            } as data"
					>
						<ng-container
							*ngTemplateOutlet="data.suggestions?.length > 0 ? suggestionsStepperTemplate : latestTimesTemplate; context: data"
						></ng-container>
					</ng-container>
				</div>
				<mat-option
					[value]="null"
					style="height: 0; display: none"
					tabindex="-1"
				></mat-option>
			</mat-autocomplete>
		</div>
		<div class="flex-auto"></div>
		<div
			#containerAccessor
			class="record-toolbar-icon-button-group flex flex-row items-center justify-center"
		>
			<ng-container *ngIf="tagTooltipData$ | async as tagTip">
				<button
					(click)="this.openTagPickerDialog($event)"
					[class.mat-accent]="tagTip.allTags?.length > 0"
					[disabled]="group.disabled"
					[matTooltipDisabled]="!tagTip.allTags?.length"
					[matTooltipTemplate]="tagPickerTooltip"
					[matTooltipTemplateContext]="tagTip"
					mat-icon-button
					matTooltip
				>
					<mat-icon inline>label</mat-icon>
				</button>
			</ng-container>
			<button
				(click)="this.togglePayment()"
				[class.mat-accent]="value$billable | async"
				[disabled]="group.disabled"
				mat-button-toggle
				mat-icon-button
			>
				<mat-icon inline>attach_money</mat-icon>
			</button>
		</div>
		<div
			*ngIf="this.SelectedRecordMode === this.modes.Timer"
			class="vertical-center ml-2 flex flex-row items-center gap-2"
		>
			@if (linkedWorkingHoursViolation$ | async) {
			<div
				[matTooltip]="'record-toolbar.linked-workinghours-violation' | translate"
				class="entry-warning-badge flex h-8 w-8 shrink-0 items-center justify-center rounded-full"
				matTooltipPosition="bottom"
			>
				<mat-icon class="entry-warning-badge-icon">warning</mat-icon>
			</div>
			}
			<tg-record-toolbar-counter [start]="this.runningTime$counter | async"></tg-record-toolbar-counter>
		</div>
		<div class="vertical-separator"></div>
		<div class="vertical-center ml-2 flex flex-row items-center justify-end gap-[10px]">
			<ng-container *ngIf="this.SelectedRecordMode === this.modes.Timer; else manualMode">
				<div
					[matTooltip]="toolbar.errors?.translate ? (toolbar.errors.translate | translate: toolbar.errors.args) : (toolbar.errors | translate)"
					*ngIf="{ errors: errors$timer | async } as toolbar"
					matTooltipPosition="bottom"
				>
					<button
						(click)="this.togglePlaying()"
						[disabled]="(group$disabled | async) || (!!(runningTime.value$ | async) && ((hasError.value$ | async) || !this.initialEnabled)) || !!(this.isLoading$ | async)"
						class="submit-time-button"
						color="accent"
						id="record_toolbar_timer_submit"
						mat-fab
					>
						<ng-container *ngIf="!(this.isLoading$ | async); else autoLoading">
							<mat-icon
								*ngIf="!(this.runningTime.value$ | async); else pauseRecordButton"
								inline
							>
								play_arrow
							</mat-icon>
							<ng-template #pauseRecordButton> <mat-icon inline>stop</mat-icon> </ng-template>
						</ng-container>
						<ng-template #autoLoading>
							<mat-progress-spinner
								[diameter]="20"
								[mode]="'indeterminate'"
								[strokeWidth]="3"
								color="accent"
							></mat-progress-spinner>
						</ng-template>
					</button>
				</div>
				<div></div>
			</ng-container>
			<ng-template #manualMode>
				<div class="text-small flex flex-row items-center justify-end gap-[10px]">
					<div class="flex flex-row items-center justify-end">
						<tg-time-range-control
							[(stateVisibleMode)]="isRangeMode"
							[control]="group.controls.time"
							[mode]="mode"
							[ngClass]="{
                'min-w-60': mode === 'range',
                'min-w-48': mode === 'duration',
              }"
							[project]="group.controls.project.value"
							class="flex items-center justify-end"
						></tg-time-range-control>
					</div>
					<div
						[matTooltip]="toolbar.errors?.translate ? (toolbar.errors.translate | translate: toolbar.errors.args) : (toolbar.errors | translate)"
						*ngIf="{ errors: errors$timer | async } as toolbar"
						matTooltipPosition="bottom"
					>
						<button
							(click)="this.saveManualData()"
							[disabled]="(group$disabled | async) || (hasError.value$ | async) || !this.initialEnabled || !!(this.isLoading$ | async)"
							class="submit-time-button"
							color="accent"
							id="record_toolbar_submit"
							mat-fab
						>
							<mat-icon
								*ngIf="!(this.isLoading$ | async); else manualLoading"
								inline
							>
								check
							</mat-icon>
							<ng-template #manualLoading>
								<mat-progress-spinner
									[diameter]="20"
									[mode]="'indeterminate'"
									[strokeWidth]="3"
									color="accent"
								></mat-progress-spinner>
							</ng-template>
						</button>
					</div>
				</div>
			</ng-template>
		</div>
		<div class="record-toolbar-side-menu ml-2">
			<button
				(click)="this.changeMode(this.modes.Timer)"
				[disabled]="isLoading"
				[ngClass]="{
          'mat-accent': this.SelectedRecordMode == this.modes.Timer,
        }"
				#SelectionModeTimer
				mat-icon-button
			>
				<mat-icon
					class
					inline
				>
					timer
				</mat-icon>
			</button>
			<button
				(click)="this.changeMode(this.modes.Manual)"
				[disabled]="isLoading"
				[ngClass]="{
          'mat-accent': this.SelectedRecordMode == this.modes.Manual,
        }"
				#SelectionModeManual
				mat-icon-button
			>
				<mat-icon
					class
					inline
				>
					edit
				</mat-icon>
			</button>
		</div>
	</mat-toolbar>
</form>
<mat-menu #timeContextMenu="matMenu">
	<ng-template
		let-data
		matMenuContent
	>
		<button
			(click)="setToNow(data.prop)"
			mat-menu-item
		>
			{{ 'timeContextMenu.setTo.now' | translate }}
		</button>
		<button
			[matMenuTriggerData]="{ $implicit: data }"
			[matMenuTriggerFor]="timeContextMenuTimeTemplates"
			mat-menu-item
		>
			{{ 'timeContextMenu.setToMore' | translate }}
		</button>
	</ng-template>
</mat-menu>
<ng-template
	#showCounter
	let-time
>
	<ng-container *ngIf="now$ | async as now">
		{{ time.start | dfnsParseIso | dfnsDifferenceInSeconds: now | parseMsAsDuration: false : false }}
	</ng-container>
</ng-template>
<ng-template
	#taskSearchTemplate
	let-searchResult="searchResult"
>
	<mat-list dense>
		<ng-container
			*ngFor="let entry of searchResult?.clients || []; let last = last; let first = first; trackBy: trackId"
		>
			<h3
				class="f-bold"
				matSubheader
			>
				<div class="text-ellipsis text-nowrap">
					{{ entry | defaultEntityTranslate: 'client' : 'client.none' }}
				</div>
			</h3>
			<div *ngFor="let project of entry.projects || []">
				<h3
					(click)="
            $event.stopPropagation();
            project.selected || project.useAsDefault
              ? this.removeProject()
              : this.changeProject({
                  id: project.id,
                  name: project.name,
                  billable: project.billable,
                  client: {
                    id: entry.id,
                    name: entry.name,
                  },
                })
          "
					[matRipple]="!project.useAsDefault"
					matSubheader
				>
					<mat-checkbox
						(click)="$event.preventDefault()"
						[checked]="project.selected"
						[disabled]="project.useAsDefault"
						[labelPosition]="'before'"
						class="mat-checkbox-flex w-full"
						color="primary"
					>
						<span
							[innerHTML]="project | defaultEntityTranslate: 'project' : 'project.none' : null : true"
						></span>
					</mat-checkbox>
				</h3>
				<ng-container
					*ngTemplateOutlet="project?.tasks.length > 0 ? autocompleteTaskItem : placeholderTask; context: { project: project, entry: entry, value: group.value.name }"
				></ng-container>
			</div>
			<mat-divider *ngIf="!last"></mat-divider>
		</ng-container>
	</mat-list>
</ng-template>
<ng-template
	#autocompleteTaskItem
	let-entry="entry"
	let-project="project"
>
	<mat-option
		(click)="
      taskSelected($event, {
        client: { id: entry.id, name: entry.name },
        task: task,
        project: project,
      })
    "
		[value]="task.name"
		*ngFor="let task of project.tasks; trackBy: trackId"
		class="text-wrap-line text-ellipsis pl-6"
	>
		{{ task?.name }}
	</mat-option>
</ng-template>
<ng-template
	#placeholderTask
	let-value="value"
>
	<mat-option
		style="height: 0; display: none"
		tabindex="-1"
		value="value"
	></mat-option>
</ng-template>
<ng-template #taskSearchLoadTemplate>
	<mat-list dense>
		<div class="m-2 flex flex-col gap-1.5">
			<div class="h-6 w-64">
				<div class="mat-skeleton"></div>
			</div>
			<div class="h-6 w-80">
				<div class="mat-skeleton"></div>
			</div>
		</div>
	</mat-list>
</ng-template>
<ng-template
	#projectPickerTooltip
	let-project="project"
	let-task="task"
>
	<div class="my-2 flex flex-col space-y-2 px-2.5 wflex-[1_0_220px]">
		@if (!clientIsDefault(project?.client)) {
		<div class="space-y-1">
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				client.single
			</h3>
			<div class="flex flex-row items-center">
				<span
					[style.backgroundColor]="clientDisplayColor(project?.client)"
					class="project-color-dot flex-shrink-0 self-center"
				></span>
				<span class="font-semibold">{{
					project?.client | defaultEntityTranslate: 'client' : 'client.none'
				}}</span>
			</div>
		</div>
		}
		<div class="space-y-1">
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				project.single
			</h3>
			<div class="flex flex-row items-center">
				<span
					[style.backgroundColor]="getProjectColor(project.id)"
					class="project-color-dot flex-shrink-0 self-center"
				></span>
				<span
					[innerHTML]="project | defaultEntityTranslate: 'project' : 'project.none' : null : true"
					class="font-semibold"
				></span>
			</div>
		</div>
		<div
			*ngIf="(project | projectProxy)?.description as desc"
			class="space-y-1"
		>
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				Description
			</h3>
			<div>{{ desc | truncate: 120 }}</div>
		</div>
	</div>
</ng-template>
<ng-template
	#tagPickerTooltip
	let-allTags="allTags"
>
	<div class="flex flex-col gap-1.5">
		<div
			*ngFor="let item of allTags; trackBy: trackId"
			class="flex items-center gap-2"
		>
			<span
				[style.backgroundColor]="tagDisplayColor(item)"
				class="project-color-dot flex-shrink-0 !cursor-default !m-0"
			></span>
			<span>{{ item.name }}</span>
		</div>
	</div>
</ng-template>
<ng-template
	#timeInfoTooltip
	let-client="client"
	let-color="color"
	let-project="project"
	let-task="task"
>
	<div class="my-2 flex flex-col space-y-2 px-2.5 wflex-[1_0_220px]">
		<div class="space-y-1">
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				client.single
			</h3>
			<div class="font-semibold">
				{{ client | defaultEntityTranslate: 'client' : 'client.none' : ('client.none' | translate) }}
			</div>
		</div>
		<div
			*ngIf="(project | projectProxy)?.description as desc"
			class="space-y-1"
		>
			<h3
				class="mat-hint text-sm italic"
				translate
			>
				Description
			</h3>
			<div>{{ desc | truncate: 120 }}</div>
		</div>
	</div>
</ng-template>
<ng-template
	#feedInfoTooltip
	let-description="description"
	let-entry="entry"
	let-icon="icon"
	let-iconUrl="iconUrl"
	let-name="name"
>
	<div class="flex min-w-32 flex-row items-start space-x-2 wflex-[1_0_220px]">
		<div class="flex flex-shrink-0 items-center">
			<img
				[src]="iconUrl"
				*ngIf="iconUrl != null; else msIcon"
				style="width: 32px"
			>
			<ng-template #msIcon>
				<ms-icon
					[icon]="icon"
					style="font-size: 32px; height: 32px; width: 32px"
				></ms-icon>
			</ng-template>
		</div>
		<div class="flex flex-col">
			<div class="font-bold">{{ name | truncate: 100 }}</div>
			<div
				*ngIf="description as desc"
				class="mt-1 text-sm"
			>
				{{ desc | parseFeedDescription | truncate: 160 }}
			</div>
			<ng-container *ngIf="!entry.isAllDay">
				<div class="mt-1 flex flex-col">
					<div class="flex items-center space-x-1">
						<div class="flex flex-row items-center justify-start gap-1.5">
							<span
								*ngIf="entry.start as startDate"
								class="mat-hint"
								>{{
									startDate | dfnsParseIso | formatDate: 'time'
								}}</span
							>
							<span class="mat-hint">-</span>
							<span
								*ngIf="entry.end as endDate"
								class="mat-hint"
								>{{
									endDate | dfnsParseIso | formatDate: 'time'
								}}</span
							>
						</div>
					</div>
					<span class="mat-hint">{{ entry.start | dfnsParseIso | dfnsFormat: 'dd. MMMM - EEEE' }}</span>
				</div>
			</ng-container>
		</div>
	</div>
</ng-template>
<ng-template #noSearchEntries>
	<div class="mx-16px h-10">
		<p class="mat-hint align-middle leading-10">{{ 'utils.noitems-search' | translate }}</p>
	</div>
</ng-template>
<ng-template
	#projectTaskSuggestionRow
	let-project="project"
	let-task="task"
	let-uppercase="uppercase"
>
	<div
		[class.text-sm]="uppercase"
		class="flex flex-auto flex-col"
	>
		<div class="flex flex-row items-center justify-start gap-2">
			<div
				[matTooltip]="'project.color' | translate"
				[style.backgroundColor]="color"
				*ngIf="project?.color ?? getProjectColor(project?.id) as color"
				class="project-color-dot self-center"
			></div>
			<ng-container *ngIf="uppercase; else projectDefaultStyle">
				<span
					[innerHTML]="project | defaultEntityTranslate: 'project' : 'project.none' : null : true"
					class="truncate font-bold uppercase"
				></span>
			</ng-container>
			<ng-template #projectDefaultStyle>
				<h3
					[innerHTML]="project | defaultEntityTranslate: 'project' : 'project.none' : null : true"
					class="mb-0 truncate text-sm2 font-bold"
				></h3>
			</ng-template>
			<div class="mat-bg-30 h-1 w-1 rounded-full"></div>
			<span
				*ngIf="uppercase; else taskDefaultStyle"
				class="truncate font-bold uppercase"
				>{{
					task?.name || ('task.none' | translate) | truncate: 40
				}}</span
			>
			<ng-template #taskDefaultStyle>
				<span class="text-sm2">{{ task?.name || ('task.none' | translate) | truncate: 40 }}</span>
			</ng-template>
		</div>
	</div>
</ng-template>
<ng-template
	#recentTimeTemplate
	let-entry="data"
>
	<button
		(click)="$event.stopPropagation(); timeSelected(entry)"
		[class.border-active]="group.value.project?.id === entry.project?.id && group.value.task?.id === entry.task?.id"
		class="mbg-card border-inactive mb-1.5 flex h-8 cursor-pointer items-center rounded-full px-2.5 text-sm opacity-80 hover:opacity-100"
		type="button"
	>
		<ng-container
			*ngTemplateOutlet="projectTaskSuggestionRow; context: { project: entry.project, task: entry.task, uppercase: true }"
		></ng-container>
	</button>
</ng-template>
<ng-template
	#recentFeedTemplate
	let-entry="data"
>
	<button
		(click)="$event.stopPropagation(); feedSelected(entry)"
		[matTooltipTemplate]="feedInfoTooltip"
		[matTooltipTemplateContext]="{
      name: entry.name,
      description: entry.description,
      icon: entry.icon,
      iconUrl: entry.iconUrl,
      entry: entry,
    }"
		class="mbg-card border-inactive mb-1.5 flex h-8 cursor-pointer items-center space-x-2 rounded-full px-2.5 text-sm opacity-80 hover:opacity-100"
		matTooltip
		type="button"
	>
		<div class="flex flex-shrink-0 items-center">
			<img
				[src]="entry.iconUrl"
				*ngIf="entry.iconUrl != null; else msIcon"
				class="w-5"
			>
			<ng-template #msIcon>
				<ms-icon
					[icon]="entry.icon"
					class="h-5 w-5 text-sm"
				></ms-icon>
			</ng-template>
		</div>
		<div class="flex items-center space-x-1">
			<span class="truncate font-bold uppercase">{{ entry.name | truncate: 40 }}</span>
		</div>
	</button>
</ng-template>
<ng-template
	#latestTimesTemplate
	let-entries="times"
>
	<ng-container *ngIf="entries">
		<div class="my-2 overflow-hidden pb-2">
			<ng-container *ngIf="!group.value.name || group.value.name.length <= 0">
				<ng-container *ngTemplateOutlet="autocompleteHeader"></ng-container>
			</ng-container>
			<div class="flex flex-col space-y-6">
				<div class="flex flex-col">
					<h1
						class="mat-hint mx-16px mb-2 text-base font-semibold"
						translate
					>
						record-toolbar.tasks
					</h1>
					<div class="-mb-16px flex flex-grow flex-wrap gap-x-2 gap-y-1 px-16px pb-16px">
						<ng-container *ngFor="let entry of entries.times; trackBy: trackId">
							<ng-container
								*ngTemplateOutlet="recentTimeTemplate; context: { data: entry.data }"
							></ng-container>
						</ng-container>
					</div>
					<div class="mx-16px flex items-center justify-end">
						<button
							(click)="showMoreTasks.value = !entries.showMoreTasks"
							*ngIf="entries.showMoreTasks !== undefined"
							class="link-button"
							color="primary"
							mat-button
						>
							{{ (showMoreTasks.value ? 'utils.show_less' : 'utils.show_more') | translate }}
						</button>
					</div>
					<div
						*ngIf="!entries.times?.length"
						class="mx-16px -mb-16px flex flex-grow flex-wrap pb-16px"
					>
						<p
							class="mat-hint mx-16px text-base italic opacity-60"
							translate
						>
							utils.noitems
						</p>
					</div>
				</div>
				<div
					*ngIf="!group.value.name || group.value.name.length <= 0"
					class="flex flex-col"
				>
					<h1
						class="mat-hint mx-16px mb-2 text-base font-semibold"
						translate
					>
						feed.name
					</h1>
					<div class="-mb-16px flex flex-grow flex-wrap gap-x-2 gap-y-1 px-16px pb-16px">
						<ng-container *ngFor="let entry of entries.feed; trackBy: trackId">
							<ng-container
								*ngTemplateOutlet="recentFeedTemplate; context: { data: entry.data }"
							></ng-container>
						</ng-container>
					</div>
					<div class="mx-16px flex items-center justify-end">
						<button
							(click)="showMoreFeed.value = !entries.showMoreFeed"
							*ngIf="entries.showMoreFeed !== undefined"
							class="link-button"
							color="primary"
							mat-button
						>
							{{ (showMoreFeed.value ? 'utils.show_less' : 'utils.show_more') | translate }}
						</button>
					</div>
					<div
						*ngIf="!entries.feed?.length"
						class="mx-16px -mb-16px flex flex-grow flex-wrap pb-16px"
					>
						<p
							class="mat-hint mx-16px text-base italic opacity-60"
							translate
						>
							utils.noitems
						</p>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</ng-template>
<ng-template
	#suggestionsStepperTemplate
	let-entries="suggestions"
>
	<div class="my-2 overflow-hidden pb-2">
		<ng-container *ngTemplateOutlet="autocompleteHeader; context: { hasMatches: true }"></ng-container>
		<h1
			class="mat-hint mx-16px mb-2 text-base font-semibold"
			translate
		>
			record-toolbar.tasks
		</h1>
		<div class="-mb-16px flex flex-grow flex-wrap gap-x-2 gap-y-1 px-16px pb-16px">
			<ng-container *ngFor="let entry of entries; trackBy: trackId">
				<button
					(click)="$event.stopPropagation(); submitSuggestion({ project: entry, task: entry.task })"
					[class.border-active]="group.value.project?.id === entry.id && group.value.task?.id === entry.task?.id"
					class="mbg-card border-inactive mb-1.5 flex h-8 cursor-pointer items-center rounded-full px-2.5 text-sm opacity-80 hover:opacity-100"
					type="button"
				>
					<ng-container
						*ngTemplateOutlet="projectTaskSuggestionRow; context: { project: entry, task: entry.task, uppercase: true }"
					></ng-container>
				</button>
			</ng-container>
		</div>
	</div>
</ng-template>
<ng-template
	#autocompleteHeader
	let-hasMatches="hasMatches"
>
	<div class="mb-4 flex flex-row items-center justify-start gap-2 px-16px">
		<mat-icon
			class="logo-icon"
			svgIcon="logoIcon"
		></mat-icon>
		<div class="flex flex-col">
			<h4
				class="my-0"
				translate
			>
				utils.suggestions
			</h4>
			<span
				*ngIf="hasMatches; else defaultSuggestionsSpeech"
				class="mat-hint"
				translate
				>record-toolbar.search-matches-speech</span
			>
			<ng-template #defaultSuggestionsSpeech>
				<span
					class="mat-hint"
					translate
					>buzz.ki-suggestions</span
				>
			</ng-template>
		</div>
	</div>
</ng-template>
